import Vue from 'vue';
import VueI18n from 'vue-i18n';
// Add language support for moment
import 'moment/locale/nl';
import 'moment/locale/fr';

Vue.use(VueI18n);

// Import translations for all available languages
import fr from './fr.json';
import nl from './nl.json';

const messages = {
    fr,
    nl,
};

import {numberFormats} from './numbers';

export let DEFAULT_LANGUAGE = 'nl';

let url = window.location.href;
if (url.includes('portal.minimax.fr') || url.includes('minimax-client-dashboard.k.elnino-acceptance.com')){
    DEFAULT_LANGUAGE = 'fr';
} else {
    DEFAULT_LANGUAGE = 'nl';
}

// Create a new vuei18n object with the locale and all messages.
export const i18n = new VueI18n({
    locale: DEFAULT_LANGUAGE,
    fallbackLocale: DEFAULT_LANGUAGE,
    messages,
    numberFormats,
});

export default i18n;



// WEBPACK FOOTER //
// ./src/languages/index.js